const TIPOS_PLANILHA = [
	{ value: 'E', label: "Emagrecimento", identifier:"emagrecimento" },
  { value: 'H', label: "Hipertrofia", identifier:"hipertrofia"}
];

export default TIPOS_PLANILHA;



// WEBPACK FOOTER //
// ./src/data/TiposPlanilha.js